import type {Citation} from "../types";
import {getTowBadgeState} from "./tow-workflow";

export type CitationTowDisplay = {
  show: boolean;
  badge: ReturnType<typeof getTowBadgeState>;
  company: string | null;
  telephone: string | null;
  dispatchDetails: string | null;
  cancellationReason: string | null;
};

export function getCitationTowDisplay(citation: Citation): CitationTowDisplay {
  const tow = citation.tow;
  const contact = tow?.dispatch?.property_contact_telephone?.contact;
  const company = contact?.name?.trim() || null;
  const telephone = contact?.telephone?.trim() || null;
  const dispatchDetails = tow?.dispatch?.details?.trim() || null;
  const cancellationReason =
    tow?.reason_for_cancelling?.trim() || tow?.dispatch?.reason_for_cancelling?.trim() || null;
  const badge = getTowBadgeState(citation);

  const hasDispatchFiles = (tow?.dispatch?.files?.length ?? 0) > 0;

  const show =
    citation.tow_required === true ||
    tow?.required === true ||
    badge.showWorkflow ||
    hasDispatchFiles ||
    Boolean(company || telephone || dispatchDetails || cancellationReason);

  return {
    show,
    badge,
    company,
    telephone,
    dispatchDetails,
    cancellationReason,
  };
}

/** Plain-text tow company line, e.g. `American Eagle Towing (951-850-8330)`. */
export function formatCitationTowCompanyLine(
  company: string | null,
  telephone: string | null,
): string | null {
  if (company && telephone) return `${company} (${telephone})`;
  return company || telephone || null;
}
